import React, { useEffect, useRef, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import styles from "../styles/Chat.module.css";
import { FiSmile } from "react-icons/fi";
import { CHAT_USER } from "@chesshotel/constants";
import Loader from "../ui/loader";
import dynamic from "next/dynamic";
import { FaPaperPlane } from "react-icons/fa";
const Picker = dynamic(() => import("emoji-picker-react"), {
  loading: () => <Loader color="blue" />,
  ssr: false,
});

export default function Chat({ sendChat, chatMessages }) {
  const [chatInput, setChatInput] = useState("");
  const [showEmojis, setShowEmojis] = useState(false);

  const { t } = useTranslation("common");

  const inputRef = useRef(null);
  const messages = useRef(null);

  useEffect(() => {
    messages.current.scrollTop = messages.current.scrollHeight;

    if (inputRef.current) inputRef.current.focus();

    window.addEventListener("keyboardDidShow", (event) => {
      updateScroll();
    });
  }, []);

  function onEmojiClick(event, emojiObject) {
    setChatInput(chatInput + emojiObject.emoji);
    setShowEmojis(false);

    inputRef.current.focus();
  }

  useEffect(() => {
    updateScroll();
  }, [chatMessages]);

  function updateScroll() {
    if (messages.current) {
      messages.current.scrollTop = messages.current.scrollHeight;
    }
  }

  function handleChatMessage() {
    if (chatInput) {
      sendChat(chatInput);
      setChatInput("");
    }
  }

  function renderChatMessages() {
    return chatMessages.map((chat, i) => {
      let msg = chat.msg;
      const isUser = chat.type === CHAT_USER;

      return (
        <div key={i} className={isUser ? styles.contUser : styles.contOpponent}>
          <div
            className={`p-2.5 rounded-lg text-sm
            ${isUser ? "self-end bg-blue-500 text-white" : "bg-gray-200"}`}
          >
            {msg}
          </div>
        </div>
      );
    });
  }

  function handleKeyPress(event) {
    if (event.charCode === 13) {
      handleChatMessage();
    }
  }

  function handleCloseEmojis(event) {
    if (event.target === event.currentTarget) {
      setShowEmojis(false);
      inputRef.current.focus();
    }
  }

  return (
    <div className={`${styles.chat} bg-gray-50`}>
      <div className={`${styles.body}`}>
        <div className={styles.messages} ref={messages}>
          {renderChatMessages()}
        </div>
        {showEmojis && (
          <div
            className="fixed flex top-0 left-0 w-full h-full z-50 items-end justify-end pb-8 pr-8"
            onClick={(e) => handleCloseEmojis(e)}
          >
            <Picker onEmojiClick={onEmojiClick} />
          </div>
        )}
        <div className={`flex items-center p-4 w-full`}>
          <div className="relative flex items-center w-full">
            <div className="relative flex flex-grow justify-center items-center">
              <input
                id="chatInput"
                className="border bg-slate-50 rounded p-2 w-full"
                autoFocus
                ref={inputRef}
                onTouchStart={() => updateScroll()}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={handleKeyPress}
                value={chatInput}
                placeholder={t("Write a message")}
              />
              <button
                onClick={() => setShowEmojis(true)}
                className={`absolute right-0.5 btn btn-icon btn-icon-lg hover:opacity-70`}
                aria-label="Emoji"
              >
                <FiSmile />
              </button>
            </div>
            <button
              onClick={handleChatMessage}
              className={`md:hidden btn btn-icon btn-icon-lg hover:opacity-70`}
              aria-label="Send"
            >
              {<FaPaperPlane />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
